/**
 * OR-74 legacy route redirects.
 *
 * Maps the old top-level operational-component routes onto the new tabbed
 * Performance Hub pages so existing bookmarks and external links keep
 * working. Returns an array of <Route> elements for inclusion under
 * <Routes> in App.tsx (or any other router setup).
 *
 * Only the *exact* legacy paths redirect; child paths (e.g. /microservices/:id
 * detail pages) are left untouched and matched by their dedicated routes.
 */

import { Navigate, Route } from 'react-router-dom'

interface Redirect {
  from: string
  to: string
}

const REDIRECTS: Redirect[] = [
  { from: 'ibs', to: '/performance-hub/ibs' },
  { from: 'e2e-flows', to: '/configure-hub/ibs?tab=e2e-flows' },
  {
    from: 'microservices',
    to: '/performance-hub/operational-components?tab=microservices',
  },
  {
    from: 'systems',
    to: '/performance-hub/operational-components?tab=systems',
  },
  {
    from: 'infrastructure',
    to: '/performance-hub/operational-components?tab=infrastructure',
  },
  {
    from: 'locations-registry',
    to: '/performance-hub/operational-components?tab=locations',
  },
  {
    from: 'teams-registry',
    to: '/performance-hub/operational-components?tab=teams',
  },
  {
    from: 'suppliers',
    to: '/performance-hub/operational-components?tab=suppliers',
  },
  {
    from: 'critical-data',
    to: '/performance-hub/operational-components?tab=critical-data',
  },
  {
    from: 'relationships',
    to: '/performance-hub/operational-components?tab=relationships',
  },
  {
    from: 'admin/bulk-performance-upload',
    to: '/performance-hub/bulk-performance-upload',
  },
]

export function performanceHubRedirects() {
  return REDIRECTS.map(({ from, to }) => (
    <Route key={from} path={from} element={<Navigate to={to} replace />} />
  ))
}
